/**
 * Tax – VAT Returns
 */

export default {
  vatReturns: {
    title: "VAT Returns",
    statuses: {
      new: "new",
      pending: "pending",
      submitted: "submitted",
      declined: "declined",
      draft: "draft",
      autoSub: "auto-submitted",
      changeStatus: "Change Status",
    },
    q1: "1 quarter",
    q2: "2 quarter",
    q3: "3 quarter",
    q4: "4 quarter",
    decl: "VAT return",
    edit: "Edit",
    taxReturn: "Tax return",
    statusChanged: "Status has been successfully changed",
    selectStatus: "Please select the status to change",
    payVat: "Pay your VAT",
    next: "Next",
    pay: "Pay",
    country: "Country",
    stNum: "Steuernummer",
    amount: "Amount",
    ref: "Reference",
    paymentComp: "Payment completed!",
    iban: "IBAN",
    bic: "BIC (Bank Identification Code)",
    bankName: "Bank name",
    accName: "Account name",
    warning: "Warning",
    planOver: "Your tarrif plan is over",
    contUsing: "You can continue using Lappa software when you subscribe.",
    selectPlan: "select plan",
    trialPeriod: "Trial period",
    notAvailable: "This function is not available in trial period",
    vatRetDetails: "VAT Return Details",
    ls: "List of sales",
    vatNumber: "VAT Number",
    salesType: "Sales type",
    forPeriod1: "For the period",
    forPeriod2: "for",
    submitDecl: "Submit declaration",
    submitLs: "Submit list of sales",
    submit: "Submit",
    wantSubmit1: "Do you want to submit declaration for",
    wantSubmit2: "for",
    wantSubmit3: "",
    clickObSubmit: `By clicking on the 'Submit' button, you agree to the following: When you submit this VAT information you are making a legal declaration that the information is true and complete. A false declaration can result in prosecution`,
    clickObSubmitCredits: `By clicking on the 'Submit' button, you acknowledge and agree that credits will be charged upon submission. You also confirm that you understand and accept these charges before submitting your request.`,
    payAutoSubmit: "30 $ auto-submit",
    payUseCredits: "Use credits",
    buyBundle: "Buy bundle",
    buyOne: "Buy one",
    quickBuyViaCreditCard: "Quick buy via credit card",
    pay: "Pay",
    hmrcInt: "HMRC integration",
    connect: "Connect",
    connectHmrc: "Please connect your HMRC account to submit declaration",
    uploadFile: "Upload file",
    fileAdded: "File has been successfully added",
    addFile: "Add file",
    chooseFile: "Choose *pdf file to upload",
    period: "Period",
    nameDoc: "Name of doc",
    vatAmount: "VAT amount",
    currency: "Currency",
    fillDate: "Filling date",
    time: "Time",
    downloadFile: "Download file",
    view: "View",
    status: "Status",
    allCntr: "All Countries",
    fromQ: "From (Quarter)",
    fromY: "From (Year)",
    tillQ: "Till (Quarter)",
    tillY: "Till (Year)",
    fillVR: "Fill VAT Return",
    orderVP: "Order VAT payment",
    total: "Total",
    delete: "Delete",
    cancel: "Cancel",
    continue: "Continue",
    hereYouCanFill: "Here you can fill your VAT returns",
    close: "Close",
  },
};
